import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetVotacoesDetalhado() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getVotacoesDetalhado = useCallback(
        (votacaoId: string) =>
            invocarApi({
                url: `/api/v1/votacao/${votacaoId}/voto/detalhado`,
                method: 'GET',
                enviarTokenUsuario: true,
                baseURL: VariaveisAmbiente.apiClickupLicUrl,
                timeout: 30000
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getVotacoesDetalhado,
    };
}
